import { render, staticRenderFns } from "./CountInscriptions.vue?vue&type=template&id=8e52da36&scoped=true&"
import script from "./CountInscriptions.vue?vue&type=script&lang=js&"
export * from "./CountInscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e52da36",
  null
  
)

export default component.exports